import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ProductDetailAdd" })
export default class ProductDetailAdd extends Vue {
    public localizer: any = Localizer;
    public validationErrors: any[] = [];
    public isLoading: boolean = false;
    public quantity: any = 1;

    @Prop() readonly product: any;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        GTagHelper.sendCustomEvent("view_item", {
            currency: "EUR",
            value: parseFloat(this.product.price.replace(/\./g, "").replace(",", ".")),
            items: [
                {
                    item_id: this.product.code,
                    item_name: this.product.title,
                    affiliation: "C&DElettronica",
                    currency: "EUR",
                    item_brand: this.product.brand,
                    item_category: this.product.categoryName,
                    price: parseFloat(this.product.price.replace(/\./g, "").replace(",", "."))
                }
            ]
        });

        this.quantity = this.product.minQuantity;
    }

    public addQuantity() {
        this.quantity ? this.quantity++ : this.quantity = 1;

        if (this.quantity > 100) {
            this.quantity = 100;
        }
    }

    public removeQuantity() {
        this.quantity > 1 ? this.quantity-- : this.quantity = 1;
    }

    public getCart() {
        this.$store.dispatch("cartStore/getCart");
    }

    public async addProduct() {
        this.isLoading = true;
        FormHelper.removeFocus();
        this.validationErrors = [];

        if (this.quantity === "") {
            this.validationErrors.push({ name: "Quantity", message: "Quantità non valida" });
        } else {
            try {
                const result = (await Axios.post(this.routes.Cart_AddProduct, { productCode: this.product.code, quantity: this.quantity })).data;

                this.$store.dispatch("cartStore/setCart", result.cartInfo);

                GTagHelper.sendCustomEvent("add_to_cart", {
                    currency: "EUR",
                    value: parseFloat(this.product.price.replace(/\./g, "").replace(",", ".")),
                    items: [
                        {
                            item_id: this.product.code,
                            item_name: this.product.title,
                            affiliation: "C&DElettronica",
                            currency: "EUR",
                            item_brand: this.product.brand,
                            item_category: this.product.categoryName,
                            price: parseFloat(this.product.price.replace(/\./g, "").replace(",", ".")),
                            quantity: this.quantity
                        }
                    ]
                });

                this.bindCartPreview();
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        }

        this.isLoading = false;
    }

    public bindCartPreview() {
        setTimeout(function () { $(".tr[data-add]").removeAttr("data-add"); }, 1500);

        var $cartDetails = $("#CartPreview");
        $cartDetails.attr("data-add", "");
        setTimeout(function () { $cartDetails.removeAttr("data-add"); }, 3000);
    };

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};